(() => {
  'use strict';

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const header = document.querySelector('[data-site-header]');

  const updateHeader = () => {
    if (header) header.classList.toggle('is-scrolled', window.scrollY > 12);
  };
  updateHeader();
  window.addEventListener('scroll', updateHeader, { passive: true });

  document.querySelectorAll('.kv-mobile-nav a').forEach((link) => {
    link.addEventListener('click', () => link.closest('details')?.removeAttribute('open'));
  });

  if (!reducedMotion && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -30px' });
    document.querySelectorAll('.kv-reveal').forEach((item) => observer.observe(item));
  } else {
    document.querySelectorAll('.kv-reveal').forEach((item) => item.classList.add('is-visible'));
  }

  const visual = document.querySelector('[data-visual-tilt]');
  if (visual && !reducedMotion) {
    visual.addEventListener('pointermove', (event) => {
      const bounds = visual.getBoundingClientRect();
      const x = ((event.clientX - bounds.left) / bounds.width) * 100;
      const y = ((event.clientY - bounds.top) / bounds.height) * 100;
      visual.style.setProperty('--mx', `${x}%`);
      visual.style.setProperty('--my', `${y}%`);
    });
  }

  document.querySelectorAll('.kv-button').forEach((button) => {
    button.addEventListener('pointerdown', (event) => {
      if (reducedMotion) return;
      const bounds = button.getBoundingClientRect();
      const ripple = document.createElement('span');
      ripple.className = 'kv-ripple';
      ripple.style.left = `${event.clientX - bounds.left}px`;
      ripple.style.top = `${event.clientY - bounds.top}px`;
      button.appendChild(ripple);
      ripple.addEventListener('animationend', () => ripple.remove(), { once: true });
    });
  });

  const privacyDialog = document.querySelector('[data-privacy-dialog]');
  const openPrivacy = () => {
    if (!privacyDialog) return;
    if (typeof privacyDialog.showModal === 'function' && !privacyDialog.open) privacyDialog.showModal();
    else privacyDialog.setAttribute('open', '');
    document.documentElement.classList.add('kv-dialog-open');
  };
  const closePrivacy = () => {
    if (!privacyDialog) return;
    if (typeof privacyDialog.close === 'function' && privacyDialog.open) privacyDialog.close();
    else privacyDialog.removeAttribute('open');
    document.documentElement.classList.remove('kv-dialog-open');
  };
  document.querySelectorAll('a[href$="#datenschutz"]').forEach((link) => {
    link.addEventListener('click', (event) => {
      if (!privacyDialog) return;
      event.preventDefault();
      openPrivacy();
      if (window.location.hash !== '#datenschutz') history.replaceState(null, '', '#datenschutz');
    });
  });
  privacyDialog?.querySelector('[data-privacy-close]')?.addEventListener('click', closePrivacy);
  privacyDialog?.addEventListener('click', (event) => {
    if (event.target === privacyDialog) closePrivacy();
  });
  privacyDialog?.addEventListener('close', () => {
    document.documentElement.classList.remove('kv-dialog-open');
    if (window.location.hash === '#datenschutz') history.replaceState(null, '', `${window.location.pathname}${window.location.search}`);
  });
  if (window.location.hash === '#datenschutz') openPrivacy();

  const partnerForm = document.querySelector('.kv-partner-form');
  if (partnerForm) {
    const partnerSteps = Array.from(partnerForm.querySelectorAll('[data-form-step]'));
    if (!partnerSteps.length) {
      partnerForm.querySelector('[data-form-success]')?.focus();
    } else {
      const partnerProgressBar = partnerForm.querySelector('[data-progress-bar]');
      const partnerProgressLabel = partnerForm.querySelector('[data-progress-label]');
      const partnerProgressTitle = partnerForm.querySelector('[data-progress-title]');
      const partnerSummary = partnerForm.querySelector('[data-form-summary]');
      const partnerStepTitles = ['Studio & Kontakt', 'Region & Leistung', 'Zusammenarbeit', 'Prüfen & senden'];
      let partnerCurrentStep = partnerForm.querySelector('[data-server-errors]') ? 0 : 0;

      const partnerFieldValue = (name) => {
        const field = partnerForm.elements.namedItem(name);
        if (!field) return '—';
        if (typeof field.length === 'number' && !field.tagName) return field.value || '—';
        if (field.tagName === 'SELECT') return field.selectedOptions[0]?.textContent?.trim() || '—';
        return field.value?.trim() || '—';
      };

      const updatePartnerSummary = () => {
        if (!partnerSummary) return;
        const rows = [
          ['Studio', partnerFieldValue('contact[Unternehmen]')],
          ['Ansprechpartner', `${partnerFieldValue('contact[name]')} · ${partnerFieldValue('contact[email]')}`],
          ['Standort', `${partnerFieldValue('contact[Postleitzahl]')} ${partnerFieldValue('contact[Ort]')}`],
          ['Betreuungsgebiet', partnerFieldValue('contact[Betreuungsgebiet]')],
          ['Radius', partnerFieldValue('contact[Betreuungsradius]')],
          ['Leistungsmodell', partnerFieldValue('contact[Leistungsmodell]')],
          ['Budgetsegment', partnerFieldValue('contact[Budgetsegment]')],
          ['Kapazität', partnerFieldValue('contact[Kapazität pro Monat]')],
          ['Reaktionszeit', partnerFieldValue('contact[Reaktionszeit]')]
        ];
        partnerSummary.replaceChildren(...rows.map(([label, value]) => {
          const row = document.createElement('div');
          row.className = 'kv-summary__row';
          const key = document.createElement('span');
          key.textContent = label;
          const content = document.createElement('b');
          content.textContent = value;
          row.append(key, content);
          return row;
        }));
      };

      const setPartnerStep = (index, shouldFocus = true) => {
        partnerCurrentStep = Math.max(0, Math.min(index, partnerSteps.length - 1));
        partnerSteps.forEach((step, stepIndex) => step.classList.toggle('is-active', stepIndex === partnerCurrentStep));
        if (partnerProgressBar) partnerProgressBar.style.width = `${((partnerCurrentStep + 1) / partnerSteps.length) * 100}%`;
        if (partnerProgressLabel) partnerProgressLabel.textContent = `Schritt ${partnerCurrentStep + 1} von ${partnerSteps.length}`;
        if (partnerProgressTitle) partnerProgressTitle.textContent = partnerStepTitles[partnerCurrentStep];
        if (partnerCurrentStep === partnerSteps.length - 1) updatePartnerSummary();
        if (shouldFocus) {
          partnerSteps[partnerCurrentStep]?.querySelector('legend')?.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'center' });
        }
      };

      const validatePartnerStep = (index) => {
        const step = partnerSteps[index];
        const error = step?.querySelector('[data-step-error]');
        if (error) error.textContent = '';
        const controls = Array.from(step?.querySelectorAll('input, select, textarea') || []);
        const invalid = controls.find((control) => !control.checkValidity());
        if (invalid) {
          if (error) {
            error.textContent = invalid.validity.valueMissing
              ? 'Bitte vervollständigen Sie die markierten Pflichtangaben.'
              : 'Bitte prüfen Sie das Format Ihrer Eingabe.';
          }
          if (step.classList.contains('is-active')) invalid.reportValidity();
          return false;
        }
        return true;
      };

      partnerForm.querySelectorAll('[data-next]').forEach((button) => {
        button.addEventListener('click', () => {
          if (validatePartnerStep(partnerCurrentStep)) setPartnerStep(partnerCurrentStep + 1);
        });
      });
      partnerForm.querySelectorAll('[data-back]').forEach((button) => {
        button.addEventListener('click', () => setPartnerStep(partnerCurrentStep - 1));
      });
      partnerForm.addEventListener('submit', (event) => {
        for (let index = 0; index < partnerSteps.length; index += 1) {
          if (!validatePartnerStep(index)) {
            event.preventDefault();
            setPartnerStep(index, false);
            partnerSteps[index].scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'center' });
            partnerSteps[index].querySelector('input:invalid, select:invalid, textarea:invalid')?.reportValidity();
            return;
          }
        }
        const submit = partnerForm.querySelector('[type="submit"]');
        if (submit) {
          submit.disabled = true;
          submit.textContent = 'Wird sicher übermittelt …';
        }
      });
      setPartnerStep(partnerCurrentStep, false);
    }
  }

  const form = document.querySelector('.kv-lead-form');
  if (!form) {
    document.querySelector('[data-form-success]')?.focus();
    return;
  }

  const steps = Array.from(form.querySelectorAll('[data-form-step]'));
  if (!steps.length) {
    document.querySelector('[data-form-success]')?.focus();
    return;
  }
  const progressBar = form.querySelector('[data-progress-bar]');
  const progressLabel = form.querySelector('[data-progress-label]');
  const progressTitle = form.querySelector('[data-progress-title]');
  const summary = form.querySelector('[data-form-summary]');
  const stepTitles = ['Deine Küche', 'Rahmen & Region', 'Dein Kontakt', 'Prüfen & senden'];
  const phoneInput = form.elements.namedItem('contact[phone]');
  const channelInput = form.elements.namedItem('contact[Kontaktweg]');
  let currentStep = form.querySelector('[data-server-errors]') ? 2 : 0;

  const fieldValue = (name) => {
    const field = form.elements.namedItem(name);
    if (!field) return '—';
    if (typeof field.length === 'number' && !field.tagName) {
      return field.value || '—';
    }
    if (field.tagName === 'SELECT') {
      return field.selectedOptions[0]?.textContent?.trim() || '—';
    }
    return field.value?.trim() || '—';
  };

  const updateSummary = () => {
    if (!summary) return;
    const rows = [
      ['Projekt', fieldValue('contact[Projektart]')],
      ['Stil', fieldValue('contact[Küchenstil]')],
      ['Form', fieldValue('contact[Küchenform]')],
      ['Budget', fieldValue('contact[Budget]')],
      ['Zeitpunkt', fieldValue('contact[Kaufzeitpunkt]')],
      ['Beratung', fieldValue('contact[Beratungsart]')],
      ['Region', fieldValue('contact[Postleitzahl]')],
      ['Kontakt', `${fieldValue('contact[first_name]')} · ${fieldValue('contact[email]')} · ${fieldValue('contact[Kontaktweg]')}`]
    ];
    summary.replaceChildren(...rows.map(([label, value]) => {
      const row = document.createElement('div');
      row.className = 'kv-summary__row';
      const key = document.createElement('span');
      key.textContent = label;
      const content = document.createElement('b');
      content.textContent = value;
      row.append(key, content);
      return row;
    }));
  };

  const syncConditionalFields = () => {
    if (!phoneInput || !channelInput) return;
    phoneInput.required = channelInput.value === 'Rückruf';
  };
  channelInput?.addEventListener('change', syncConditionalFields);

  const setStep = (index, shouldFocus = true) => {
    currentStep = Math.max(0, Math.min(index, steps.length - 1));
    steps.forEach((step, stepIndex) => step.classList.toggle('is-active', stepIndex === currentStep));
    if (progressBar) progressBar.style.width = `${((currentStep + 1) / steps.length) * 100}%`;
    if (progressLabel) progressLabel.textContent = `Schritt ${currentStep + 1} von ${steps.length}`;
    if (progressTitle) progressTitle.textContent = stepTitles[currentStep];
    if (currentStep === steps.length - 1) updateSummary();
    if (shouldFocus) {
      steps[currentStep]?.querySelector('legend')?.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'center' });
    }
  };

  const validateStep = (index) => {
    syncConditionalFields();
    const step = steps[index];
    const error = step?.querySelector('[data-step-error]');
    if (error) error.textContent = '';
    const controls = Array.from(step?.querySelectorAll('input, select, textarea') || []);
    const invalid = controls.find((control) => !control.checkValidity());
    if (invalid) {
      if (error) {
        error.textContent = invalid.validity.valueMissing
          ? 'Bitte vervollständige die markierten Pflichtangaben.'
          : 'Bitte prüfe das Format deiner Eingabe.';
      }
      if (step.classList.contains('is-active')) invalid.reportValidity();
      return false;
    }
    return true;
  };

  form.querySelectorAll('[data-next]').forEach((button) => {
    button.addEventListener('click', () => {
      if (validateStep(currentStep)) setStep(currentStep + 1);
    });
  });
  form.querySelectorAll('[data-back]').forEach((button) => {
    button.addEventListener('click', () => setStep(currentStep - 1));
  });

  form.addEventListener('submit', (event) => {
    for (let index = 0; index < steps.length; index += 1) {
      if (!validateStep(index)) {
        event.preventDefault();
        setStep(index, false);
        steps[index].scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'center' });
        steps[index].querySelector('input:invalid, select:invalid, textarea:invalid')?.reportValidity();
        return;
      }
    }
    const submit = form.querySelector('[type="submit"]');
    if (submit) {
      submit.disabled = true;
      submit.textContent = 'Wird sicher übermittelt …';
    }
  });

  document.querySelectorAll('[data-prefill-style]').forEach((link) => {
    link.addEventListener('click', () => {
      const desired = link.dataset.prefillStyle;
      const choices = Array.from(form.elements.namedItem('contact[Küchenstil]') || []);
      const match = choices.find((choice) => choice.value === desired);
      if (match) match.checked = true;
      setStep(0, false);
    });
  });

  setStep(currentStep, false);
})();
